import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Plus } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const AMOUNTS = [1000, 3000, 6000, 12000];
const METHODS = [
  { id: "wave", label: "Wave", cls: "bg-blue-500" },
  { id: "orange_money", label: "Orange Money", cls: "bg-orange-500" },
];

// Recharge du portefeuille abonnement via Wave ou Orange Money
export const SubscriptionTopup = ({ user, onDone }) => {
  const [open, setOpen] = useState(false);
  const [amount, setAmount] = useState(1000);
  const [method, setMethod] = useState("wave");
  const [phone, setPhone] = useState(user?.phone || "");
  const [loading, setLoading] = useState(false);

  const submit = async () => {
    setLoading(true);
    try {
      const { data } = await axios.post(`${API}/credits/purchase`, {
        user_id: user.id, amount, payment_method: method, payment_phone: phone, purpose: "subscription",
      });
      if (data.wave_payment_url) window.open(data.wave_payment_url, "_blank", "noopener");
      toast.success(data.message || "Recharge enregistrée");
      setOpen(false);
      onDone?.();
    } catch (e) {
      toast.error(e.response?.data?.detail || "Recharge impossible");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <button type="button" onClick={() => setOpen(true)} className="rounded-full bg-[#D4AF37] text-[#0F172A] px-5 py-2.5 text-[11px] font-black uppercase tracking-widest flex items-center gap-2 active:scale-95 transition-transform" data-testid="subscription-topup-btn">
        <Plus size={14} /> Recharger
      </button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="bg-[#1A1A1A] border-white/10 text-white rounded-3xl max-w-md" data-testid="subscription-topup-dialog">
          <DialogHeader>
            <DialogTitle className="font-black uppercase tracking-widest text-base">Recharger mon abonnement</DialogTitle>
            <DialogDescription className="text-white/60 text-sm">1 000 FCFA = 1 mois de visibilité.</DialogDescription>
          </DialogHeader>
          <div className="grid grid-cols-4 gap-2">
            {AMOUNTS.map((a) => (
              <button key={a} type="button" onClick={() => setAmount(a)} className={`rounded-xl py-2 text-xs font-black transition-colors ${amount === a ? "bg-[#D4AF37] text-[#0F172A]" : "bg-white/10 text-white hover:bg-white/20"}`} data-testid={`subscription-amount-${a}`}>
                {new Intl.NumberFormat("fr-FR").format(a)}
              </button>
            ))}
          </div>
          <div className="grid grid-cols-2 gap-2">
            {METHODS.map((m) => (
              <button key={m.id} type="button" onClick={() => setMethod(m.id)} className={`rounded-xl py-3 text-sm font-bold transition-opacity ${m.cls} ${method === m.id ? "opacity-100 ring-2 ring-white" : "opacity-50"}`} data-testid={`subscription-method-${m.id}`}>
                {m.label}
              </button>
            ))}
          </div>
          <Input value={phone} onChange={(e) => setPhone(e.target.value)} placeholder="Numéro de paiement (77 123 45 67)" className="bg-white/5 border-white/20 text-white" data-testid="subscription-phone-input" />
          <button type="button" onClick={submit} disabled={loading} className="w-full rounded-full bg-[#D4AF37] text-[#0F172A] py-3 font-black uppercase tracking-widest text-xs disabled:opacity-50" data-testid="subscription-topup-submit">
            {loading ? "Envoi..." : `Payer ${new Intl.NumberFormat("fr-FR").format(amount)} FCFA`}
          </button>
          <p className="text-[11px] text-white/50 text-center">Orange Money et Wave manuel : votre solde est crédité après vérification par l'équipe WÔMA.</p>
        </DialogContent>
      </Dialog>
    </>
  );
};
